import { getHash } from '@utils';

/**
 * Generates a temporary credential to be used with the REST API using the given
 * email and user ID. The credential is good for up to 1 minute.
 */
export function getBasicAuthCredentials(
  email: string,
  userId: string,
  getPrevious = false,
): string {
  if (!email || !userId) {
    return '';
  }

  // The time component of the auth credentials ensures this credential will
  // expire.
  let time = Math.floor(Date.now() / 1_000 / 60);

  // To avoid users being refused when authenticating at the last second of the
  // current minute, also support retrieving the previous auth credential.
  if (getPrevious) {
    time -= 1_000 * 60;
  }

  // Instead of using a password, use a temporary code that will expire in a
  // minute.
  const password = getHash(`${time}-${userId}`);

  return `${email}:${password}`;
}
